import React from 'react'
import iconNames from 'theme/icons'
import {t} from "helpers/language"

export const skill = {
  key: "ADD_CONTACT",
  group: 'contacts',
  label: t("Add a contact"),
  desc: t("Quickly add a new contact you're dealing with into your database"),
  steps: [
    {
      target: '.header-addButton',
      content: <div>To add a contact <i>Tap The Add Button</i>. You can use this button at any time to add a new contact, activity or quote.</div>,
    },
    {
      target: '.addMenu-addContact',
      content: <div><i>Tap Add Contact</i> to add a new contact</div>,
      placement: 'left',
      awaitElement: {interval: 100},
    },
    {
      // Inline tooltip in contact dialog
      dummy: true,
      addContactDialog: true, // sets the page number on the contact dialog
    },
    {
      firstTimeOnly: true,
      title: "Contact Added",
      titleIcon: iconNames.tick,
      titleIconColor: "green",
      content: (
        <div>
          {"Great, you've added your first contact!"}<br/>
          <br/>
          {"So, what's next? If you have an existing contact database, you can import them now from a CSV file."}
        </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Learn How To Import Contacts",
          primary: true,
          type: "skill",
          location: "/contacts/import",
          page: 0,
          skill: "IMPORT_CONTACTS",
        },
      ],
    },
  ],
}

export default skill
